import { render, staticRenderFns } from "./main-loading.vue?vue&type=template&id=74a66dac&scoped=true"
import script from "./main-loading.vue?vue&type=script&lang=js"
export * from "./main-loading.vue?vue&type=script&lang=js"
import style0 from "./main-loading.vue?vue&type=style&index=0&id=74a66dac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a66dac",
  null
  
)

export default component.exports